<ion-content>
  <div class="px-4 py-2 padding-bottom-configuration">
    <app-header-configuration
      [title]="'P0003607.installation.desinfection.titre' | translate"
      [description]="
        'P0003607.installation.desinfection.description' | translate
      "
    >
    </app-header-configuration>

    @if (hasProduitP00032()) {
      <app-label-configuration
        [title]="'P0003607.installation.regulation' | translate"
        [titleListe]="'P0003607.installation.regulation.value' | translate"
        [information]="P0003607ESPInstallationClModal"
        [value]="actionStack!.getValue('esPConsigneRx')"
        [liste]="P0003605ConsigneRegulationRxEnum"
        (onPress)="
          this.actionStack!.editValue(
            P00039DataRxTxIndex.ElectrolyseurStandard_Parametrage,
            'esPConsigneRx',
            $event,
            null
          )
        "
      >
      </app-label-configuration>

      <app-label-configuration
        [titleListe]="'P0003607.installation.hysteresis.value' | translate"
        [value]="actionStack!.getValue('esPHysteresisRegulationRx')"
        [liste]="P0003607HysteresisValues"
        [warningMode]="getProductDeviceTableFromPool()"
        (onPress)="
          this.actionStack!.editValue(
            P00039DataRxTxIndex.ElectrolyseurStandard_Parametrage,
            'esPHysteresisRegulationRx',
            $event,
            null
          )
        "
      >
      </app-label-configuration>

      <app-switch-configuration
        [nameCustom]="'P0003607.installation.automaintien.value' | translate"
        [value]="
          actionStack!.getValue('esIActivationFonctionAutoMaintien') !== 0
        "
        (onPress)="
          this.actionStack!.editValue(
            P00039DataRxTxIndex.ElectrolyseurStandard_Installation,
            'esIActivationFonctionAutoMaintien',
            $event ? 1 : 0,
            null
          )
        "
      >
      </app-switch-configuration>

      <app-label-description
        [description]="
          'P0003607.installation.regulation.description' | translate
        "
      ></app-label-description>
    }

    <app-information-title
      [title]="'P0003607.installation.horloge' | translate"
      [information]="openEnSavoirPlus"
    ></app-information-title>

    <app-two-choices-control
      [firstLabel]="
        'P00039.lighting.functionality.parameters.setting.title.clock.day'
          | translate
      "
      [firstValue]="0"
      [secondLabel]="
        'P00039.lighting.functionality.parameters.setting.title.clock.week'
          | translate
      "
      [secondValue]="1"
      [value]="actionStack!.getValue('esPTypeHorloge')"
      (onChange)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.ElectrolyseurStandard_Parametrage,
          'esPTypeHorloge',
          $event,
          null
        )
      "
    >
    </app-two-choices-control>

    @if (this.actionStack!.getValue('esPTypeHorloge') === 0) {
      <app-larged-link
        [name]="
          'P0003600.installation.filtration.programmePPH.horlogePicotsJoursPPH.programmeTitre'
            | translate
        "
        (onPress)="goToFunctionParametersSettingsClockScreen()"
      >
      </app-larged-link>
    } @else {
      <app-larged-link
        [name]="
          'P0003600.installation.filtration.programmePPH.horlogePicotsJoursPPH.programmeTitre'
            | translate
        "
        (onPress)="goToFunctionParametersSettingClockWeekScreen()"
      >
      </app-larged-link>
    }

    <app-label-description
      [description]="'P0003607.installation.descriptionHorloge' | translate"
    ></app-label-description>

    <app-switch-configuration
      [title]="'P0003607.installation.comportement' | translate"
      [nameCustom]="'P0003607.installation.comportement.value' | translate"
      [description]="
        'P0003607.installation.comportement.description' | translate
      "
      [value]="
        actionStack!.getValue('esIActivationFonctionPrioriteElectrolyse') !== 0
      "
      (onPress)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.ElectrolyseurStandard_Installation,
          'esIActivationFonctionPrioriteElectrolyse',
          $event ? 1 : 0,
          null
        )
      "
    >
    </app-switch-configuration>

    @if (actionStack!.getValue('esIMethodeAsservissement') === 0) {
      <app-label-configuration
        [title]="'P0003607.installation.volet' | translate"
        [titleListe]="'P0003607.installation.abaissement' | translate"
        [description]="
          'P0003607.installation.abaissementProduction.description' | translate
        "
        [value]="actionStack!.getValue('esPTauxAbaissement')"
        [liste]="P0003607TauxAbaissement"
        (onPress)="
          this.actionStack!.editValue(
            P00039DataRxTxIndex.ElectrolyseurStandard_Parametrage2,
            'esPTauxAbaissement',
            $event,
            null
          )
        "
      >
      </app-label-configuration>
    }
  </div>
</ion-content>

<div class="position-absolute start-0 end-0 bottom-0 bg-white px-4 py-2">
  <div class="row">
    <div class="col-6 text-start">
      <ion-button
        color="medium"
        expand="block"
        fill="outline"
        class="mb-3"
        (click)="this.prev()"
      >
        {{ 'generic.retour' | translate }}
      </ion-button>
    </div>
    <div class="col-6 text-end">
      <ion-button color="primary" expand="block" (click)="onSubmit()">
        {{ 'generic.next' | translate }}
      </ion-button>
    </div>
  </div>
</div>
